import type { FactorOfSixty } from 'pos-client/components/scheduleBoard/types/boardTypes.ts';

export const height = `calc(100vh - 100px)`;
export const views = [
  {
    type: 'day' as const,
    maxAppointmentsPerCell: 2,
  },
];
export const groups = ['laneId'];
export const editing = {
  allowAdding: false, // disable clicking on cell to add
  allowDeleting: true,
  allowResizing: true,
  allowDragging: true,
  allowUpdating: true,
};
export const dateFormat = 'dddd Do MMMM YYYY';
export const cellDuration: FactorOfSixty = 6;
